import React from "react";
import "../theme.css";

export default function BottomSection() {
  return (
    <section className="bottom">
      <h2 className="bottom-title">See IntelliTutor in Action</h2>

      <p className="bottom-desc">
        AI-powered learning plans, doubt resolution, question paper generation,
        and more — all in one platform.
      </p>

      <div className="mockup-box">
        <p>[ Insert AI Dashboard Mockup Image Here ]</p>
      </div>

      <button className="primary-btn bottom-cta">Join IntelliTutor for Free →</button>
    </section>
  );
}
